export default __webpack_public_path__ + "static/media/OCBC_Bank_logo_logotype_Singapore.1d71f5fe.png";